import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';

const CarouselContentComponent = (props) => {
  const { reviewText, name, title, profitPercentage } = props.reviewItem;
  return (
    <div id={styles.cardSection}>
      <div className={`${styles.cardComponent} ${styles.cardChildComponent}`}>
        <p className={styles.featureMainText} style={{ fontWeight: 400 }}>
          "{reviewText}"
        </p>
      </div>
      <Grid container spacing={0} className="d-flex align-items-end mt-2 mb-2">
        {/* <div className={styles.reviewImg}>
            <img
              alt="arzooo-header-logo"
              className={styles.headerLogo}
              src="/images/ellipse6.svg"
            ></img>
          </div> */}
        <div className={`${styles.cardComponent}`}>
          <h4 className={`${styles.reviewerText} mb-0`}>{name}</h4>
          <small className={`${styles.featureText}`}>{title}</small>
        </div>
      </Grid>
      <div className={styles.cardComponent} style={{ borderTop: '1px solid #F2F1F3' }}>
        <div className="d-flex align-items-center">
          <div className={styles.arrowIcon}>
            <img
              alt="arzooo-header-logo"
              className={styles.headerLogo}
              src="/images/arrow.svg"
            ></img>
          </div>
          <h4 className={`${styles.reviewerText} ${styles.percentageFont} mb-0 mr-2`}>
            {profitPercentage}
          </h4>{' '}
          <h6 className={`${styles.featureMainText} mb-0`}>increase in business</h6>
        </div>
      </div>
    </div>
  );
};
export default CarouselContentComponent;
